import diContainer from '../../bps/utilities/js/diContainer/diContainer';

// Objects needed for injection into generic components
import {productBoxSettings} from './productBox/productBoxSettings';
import {productBoxWideSettings} from './productBoxWide/productBoxWideSettings';
import {productDetailsSettings} from './productDetails/productDetailsSettings';
import {productContentBlockSettings} from './productContentBlock/productContentBlockSettings';
import {productsOrderTableSettings} from '../../bps/components/productsOrderTable/productsOrderTableSettings';
import {priceHelper} from '../utilities/js/priceHelper/priceHelper';
import {videoPlayerSettings} from '../../bps/components/videoPlayer/videoPlayerSettings';
import {productFeaturesSettings} from '../../bps/components/productFeatures/productFeaturesSettings';
import {accountRecurringOrderItemSettings} from './accountRecurringOrderItem/accountRecurringOrderItemSettings';
import {formSettings} from './form/formSettings';
import {ValidationFieldConfig, ValidationValues} from '../../bps/utilities/js/validation/ValidationFieldConfig';
//
import {TransformerPipeline} from '../../bps/utilities/js/imageUrlTransformer/TransformerPipeline';
import {transformSpaces} from '../../bps/utilities/js/imageUrlTransformer/urlTransformers';

const imageUrlTransformer = new TransformerPipeline();
imageUrlTransformer.add(transformSpaces);

diContainer.add({
  productBoxSettings,
  productBoxWideSettings,
  productDetailsSettings,
  productContentBlockSettings,
  productsOrderTableSettings,
  videoPlayerSettings,
  priceHelper,
  productFeaturesSettings,
  accountRecurringOrderItemSettings,
  formSettings,
  ValidationFieldConfig,
  ValidationValues,
  validationRules: () => import(/* webpackChunkName: "form" */ '../utilities/js/validation/validationRules'),
  imageUrlTransformer,
});
